'use client';

import { c as _c } from "react/compiler-runtime";
import { ko } from 'date-fns/locale';
import dayjs from 'dayjs';
import React, { useEffect, useRef, useState } from 'react';
import type { DateRange as PickerDateRange, DayPickerRangeProps } from 'react-day-picker';
import { DayPicker } from 'react-day-picker';
import SvgTextfieldclose from '../../../__generated__/icon/SvgTextfieldclose';
import { Input } from '../Input/Input';
export type DateRange = PickerDateRange;
interface DateRangePickerProps {
  dateRange?: DateRange;
  onChange: (dateRange?: DateRange) => void;
  placeholder?: string;
  dimensions?: 'H40';
  dayPickerProps?: Omit<DayPickerRangeProps, 'mode'>;
}
const TEXT_VALUE_MAX_LENGTH = 29;
export const DateRangePicker = t0 => {
  const $ = _c(30);
  const {
    dateRange,
    onChange,
    placeholder: t1,
    dimensions,
    dayPickerProps
  } = t0;
  const placeholder = t1 === undefined ? "\uB0A0\uC9DC\uB97C \uC120\uD0DD\uD558\uC138\uC694" : t1;
  const pickerRef = useRef(null);
  const [dateRangeText, setDateRangeText] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleClickOutside = event => {
        if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== dateRange) {
    t4 = () => {
      if (dateRange?.from && dateRange?.to) {
        setDateRangeText(`${dayjs(dateRange.from).format("YYYY. MM. DD.")} ~ ${dayjs(dateRange.to).format("YYYY. MM. DD.")}`);
      } else {
        if (dateRange?.from) {
          setDateRangeText(dayjs(dateRange.from).format("YYYY. MM. DD. ~ "));
        } else {
          setDateRangeText("");
        }
      }
    };
    $[2] = dateRange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = dateRange?.from;
  const t6 = dateRange?.to;
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = [t5, t6];
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  useEffect(t4, t7);
  let t8;
  if ($[7] !== dateRange || $[8] !== onChange) {
    t8 = day => {
      if (!dateRange?.from) {
        onChange({
          from: day,
          to: undefined
        });
        return;
      }
      if (!dateRange.to) {
        if (day > dateRange.from) {
          onChange({
            from: dateRange.from,
            to: day
          });
          return;
        }
        onChange({
          from: day,
          to: dateRange.from
        });
        return;
      }
      onChange({
        from: day,
        to: undefined
      });
    };
    $[7] = dateRange;
    $[8] = onChange;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const handleDayClick = t8;
  const formatDateRange = _temp;
  let t9;
  if ($[10] !== onChange) {
    t9 = event_0 => {
      const formattedTextValue = formatDateRange(event_0.target.value.trim());
      setDateRangeText(formattedTextValue);
      const [fromText, toText] = formattedTextValue.split("~");
      if (formattedTextValue.length === TEXT_VALUE_MAX_LENGTH && dayjs(fromText).isValid() && dayjs(toText).isValid()) {
        onChange({
          from: new Date(fromText),
          to: new Date(toText)
        });
      }
    };
    $[10] = onChange;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handleInputChange = t9;
  let t10;
  if ($[12] !== dateRangeText || $[13] !== onChange) {
    t10 = dateRangeText ? <div className="flex items-center"><button aria-label={"\uAE30\uAC04 \uCD08\uAE30\uD654"} className="flex size-30 items-center justify-center" onClick={event_1 => {
        setDateRangeText("");
        onChange();
        event_1.stopPropagation();
      }}><SvgTextfieldclose className="size-18" /></button></div> : undefined;
    $[12] = dateRangeText;
    $[13] = onChange;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setIsOpen(true);
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== dateRangeText || $[17] !== dimensions || $[18] !== handleInputChange || $[19] !== placeholder || $[20] !== t10) {
    t12 = <Input dimensions={dimensions} type="button" autoComplete="off" className="min-w-290 rounded-xxsmall" maxLength={TEXT_VALUE_MAX_LENGTH} placeholder={placeholder} rightContent={t10} value={dateRangeText} onChange={handleInputChange} onFocus={t11} />;
    $[16] = dateRangeText;
    $[17] = dimensions;
    $[18] = handleInputChange;
    $[19] = placeholder;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== dateRange || $[23] !== dayPickerProps || $[24] !== handleDayClick || $[25] !== isOpen) {
    t13 = isOpen ? <div className="absolute top-full z-10 rounded-xxsmall border-1 border-Gray-300 bg-Gray-white p-10"><DayPicker classNames={{
        caption: "flex justify-between items-center",
        nav: "flex h-40",
        nav_button: "w-40 h-40 flex justify-center items-center",
        button: "w-full h-full",
        cell: "w-40 h-40 text-center",
        day_selected: "bg-Gray-black text-Gray-white",
        day_range_start: "!bg-Gray-900 rounded-s-pill",
        day_range_end: "!bg-Gray-900 rounded-e-pill",
        day_range_middle: "!bg-Gray-500",
        day_disabled: "!text-Gray-300 !cursor-not-allowed !opacity-100",
        day_outside: "!text-Gray-300 !opacity-50"
      }} locale={ko} mode="range" selected={dateRange} onDayClick={handleDayClick} {...dayPickerProps} /></div> : null;
    $[22] = dateRange;
    $[23] = dayPickerProps;
    $[24] = handleDayClick;
    $[25] = isOpen;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <div ref={pickerRef} className="relative">{t12}{t13}</div>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
function _temp(value) {
  if (/^\d+$/.test(value) && value.length === 8) {
    const year = value.slice(0, 4);
    const month = value.slice(4, 6);
    const day_0 = value.slice(6, 8);
    return `${year}. ${month}. ${day_0}. ~ `;
  }
  if (value.length > 15) {
    const potentialDate = value.slice(-8);
    if (/^\d+$/.test(potentialDate) && potentialDate.length === 8) {
      const year_0 = potentialDate.slice(0, 4);
      const month_0 = potentialDate.slice(4, 6);
      const day_1 = potentialDate.slice(6, 8);
      return `${value.slice(0, -8)}${year_0}. ${month_0}. ${day_1}.`;
    }
  }
  return value;
}